import { useAuthorizationContext } from "./AuthorizationContext";

export function useAuthorization() {
  return useAuthorizationContext();
}
